<template>
  <div class="header-nav">
    <div class="nav-left">
      <div class="logo-section">
        <div class="logo-icon-wrapper">
          <img src="/images/mpcjqga8-ikr3zur.svg" alt="logo" class="logo-icon">
        </div>
        <img src="/images/mpcjqga8-fan0dcu.svg" alt="logo" class="logo-text">
        <div class="version-tag">
          <span>企业版</span>
        </div>
      </div>
      <a-menu 
        mode="horizontal" 
        class="main-menu" 
        :selectedKeys="selectedKeys" 
        theme="dark"
        :style="{ background: 'transparent', borderBottom: 'none', lineHeight: '56px' }"
      >
        <a-menu-item key="4" class="nav-menu-item nav-menu-item-highlight">
          <span class="menu-text">业务外包</span>
        </a-menu-item>
      </a-menu>
    </div>
    <div class="nav-right">
      <div class="ai-assistant">
        <img src="/images/mpcjqgan-rcwja0k.png" alt="AI" class="ai-avatar">
        <span class="ai-title">小桐AI</span>
      </div>
      <div class="icon-buttons">
        <div class="icon-btn">
          <img src="/images/mpcjqga8-6tzabq0.svg" alt="icon" class="icon-img">
        </div>
        <div class="icon-btn">
          <img src="/images/mpcjqga8-yknzuxj.svg" alt="icon" class="icon-img">
        </div>
        <a-badge :count="12" :overflow-count="99" class="notification-badge">
          <div class="icon-btn notification">
            <img src="/images/mpcjqga8-fi6ssfc.svg" alt="notification" class="bell-icon">
          </div>
        </a-badge>
      </div>
      <a-divider type="vertical" class="nav-divider" />
      <div class="user-section">
        <a-avatar src="/images/mpcjqgan-8d6nnsz.png" :size="24" class="user-avatar" />
        <div class="user-info">
          <span class="company-name">净海贸易</span>
          <img src="/images/mpcjqga8-kxzl5gf.svg" alt="arrow" class="arrow-icon">
        </div>
        <a-button type="link" class="logout-btn">退出</a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderNav',
  data() {
    return {
      selectedKeys: ['4']
    }
  }
}
</script>

<style scoped>
.header-nav {
  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  background: #303c54;
  padding-top: 12px;
  padding-bottom: 12px;
  width: 100%;
}

.nav-left {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
}

.logo-section {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  column-gap: 8px;
  padding-right: 26px;
  padding-left: 16px;
}

.logo-icon-wrapper {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  column-gap: 8px;
}

.logo-icon {
  width: 32px;
  height: 29px;
}

.logo-text {
  width: 72px;
  height: 18px;
}

.version-tag {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  box-shadow: inset 1px 0px 0px 0px #ededf0;
  background: #303c54;
  padding-right: 8px;
  padding-left: 8px;
}

.version-tag span {
  flex-shrink: 0;
  line-height: 20px;
  letter-spacing: 0;
  color: #f2f3f5;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimHei, Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.main-menu {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  background: transparent !important;
  border-bottom: none !important;
  line-height: 1;
}

.main-menu >>> .ant-menu-item,
.main-menu ::v-deep .ant-menu-item {
  padding: 0 16px;
  margin: 0;
  height: auto;
  line-height: 1;
  background: transparent !important;
  border-bottom: none !important;
}

.main-menu >>> .ant-menu-item::after,
.main-menu ::v-deep .ant-menu-item::after {
  display: none !important;
  border-bottom: none !important;
}

.main-menu >>> .ant-menu-item:hover,
.main-menu ::v-deep .ant-menu-item:hover {
  background: transparent !important;
  border-bottom: none !important;
}

.main-menu >>> .ant-menu-item-selected,
.main-menu ::v-deep .ant-menu-item-selected {
  background: transparent !important;
  border-bottom: none !important;
}

.main-menu >>> .ant-menu-item-selected::after,
.main-menu ::v-deep .ant-menu-item-selected::after {
  display: none !important;
  border-bottom: none !important;
}

.menu-text {
  flex-shrink: 0;
  padding: 0;
  line-height: 24px;
  letter-spacing: 0;
  color: #f2f3f5;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimHei, Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s;
}

.main-menu >>> .ant-menu-item:hover .menu-text,
.main-menu ::v-deep .ant-menu-item:hover .menu-text {
  color: #fc6732;
}

.main-menu >>> .ant-menu-item-selected .menu-text,
.main-menu ::v-deep .ant-menu-item-selected .menu-text {
  color: #fc6732;
}

.nav-right {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  column-gap: 16px;
}

.ai-assistant {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  border-radius: 8px;
  background: #4f596e;
  padding-right: 8px;
  padding-left: 8px;
  height: 40px;
}

.ai-avatar {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.ai-title {
  flex-shrink: 0;
  line-height: 22px;
  letter-spacing: 0;
  color: #ffffff;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimHei, Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.icon-buttons {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  column-gap: 17px;
  border-radius: 8px;
  background: #4f596e;
  padding-right: 4px;
  padding-left: 4px;
  height: 40px;
}

.icon-btn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  cursor: pointer;
  overflow: hidden;
}

.icon-btn:first-child {
  border-radius: 4px;
}

.icon-btn:nth-child(2) {
  border-radius: 8px;
}

.icon-img {
  width: 100%;
  height: 100%;
}

.notification-badge {
  display: flex;
  align-items: center;
}

.notification {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bell-icon {
  width: 18px;
  height: 18px;
}

.nav-divider {
  flex-shrink: 0;
  background: #788090;
  height: 18px;
  margin: 0;
}

.user-section {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  column-gap: 16px;
  padding-right: 16px;
}

.user-avatar {
  flex-shrink: 0;
  border-radius: 12px;
}

.user-info {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  column-gap: 8px;
}

.company-name {
  flex-shrink: 0;
  line-height: 22px;
  letter-spacing: 0;
  color: #f6f7f8;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimHei, Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.arrow-icon {
  flex-shrink: 0;
  width: 16px;
  height: 14px;
}

.logout-btn {
  flex-shrink: 0;
  line-height: 22px;
  letter-spacing: 0;
  color: #fc6732;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", SimHei, Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 600;
  padding: 0;
  height: auto;
}

.logout-btn:hover {
  color: #ff8c5a;
}

.nav-menu-item-highlight .menu-text {
  color: #fc6732 !important;
  font-weight: 700;
}
</style>
